export const PROCESSINGS_SET = 'PROCESSINGS_SET';
export const PROCESSINGS_ADD = 'PROCESSINGS_ADD';
export const PROCESSING_UPDATE = 'PROCESSING_UPDATE';
export const PROCESSING_DELETE = 'PROCESSING_DELETE';

export const PROCESSINGS_BY_DATA_ID_SET = 'PROCESSINGS_BY_DATA_ID_SET';
export const PROCESSINGS_BY_DATA_ID_ADD = 'PROCESSINGS_BY_DATA_ID_ADD';
export const PROCESSING_BY_DATA_ID_UPDATE = 'PROCESSING_BY_DATA_ID_UPDATE';
export const PROCESSING_BY_DATA_ID_DELETE = 'PROCESSING_BY_DATA_ID_DELETE';